import { type SideMenuState } from './side-menu-state';

const getResizedSideMenuState = (previous: SideMenuState): SideMenuState => ({
  collapsed: previous.collapsed,
  persistent: window.innerWidth >= 992,
  sideMenuKey: previous.sideMenuKey + 1,
});

export default getResizedSideMenuState;
